<!-- 内容审核与上下线 -->
<template>
  <div>
    <bread-crumb></bread-crumb>
    <div class="search-bar">
      <div class="input-group">
        <el-input
          style="width: 32%"
          v-model="searchParams.title"
          placeholder="请输入帖子标题"
          clearable
        ></el-input>
        <el-input
          style="width: 32%"
          v-model="searchParams.postIds"
          placeholder="请输入帖子ID"
          clearable
        ></el-input>
        <el-input
          style="width: 32%"
          v-model="searchParams.communityIds"
          placeholder="请输入所属圈子ID"
          clearable
        ></el-input>
        <el-input
          style="width: 32%"
          v-model="searchParams.authorPin"
          placeholder="请输入发布者pin"
          clearable
        ></el-input>
        <el-input
          style="width: 32%"
          v-model="searchParams.titleSearchKeyword"
          placeholder="请输入帖子标题关键字"
          clearable
        ></el-input>
        <el-input
          style="width: 32%"
          v-model="searchParams.contentSearchKeyword"
          placeholder="请输入帖子全文关键字"
          clearable
        ></el-input>
        <el-select
          style="width: 32%"
          v-model="searchParams.postLevelList"
          placeholder="请选择分级"
          multiple
          clearable
        >
          <el-option label="未设置" value="0"></el-option>
          <el-option label="D级" value="1"></el-option>
          <el-option label="C级" value="2"></el-option>
          <el-option label="B级" value="3"></el-option>
          <el-option label="A级" value="4"></el-option>
          <el-option label="S级" value="5"></el-option>
        </el-select>
        <el-select
          style="width: 32%"
          v-model="searchParams.communityPostType"
          placeholder="请选择帖子类型"
          multiple
          clearable
        >
          <el-option
            v-if="circleForm?.tenantId != 492"
            label="普通帖"
            value="1"
          ></el-option>
          <el-option
            v-if="circleForm?.tenantId != 492"
            label="PK帖"
            value="2"
          ></el-option>
          <el-option
            v-if="circleForm?.tenantId != 492"
            label="投票帖"
            value="3"
          ></el-option>
          <el-option
            v-if="circleForm?.tenantId != 492"
            label="课程贴"
            value="6"
          ></el-option>
          <el-option
            v-if="circleForm?.tenantId != 492"
            label="广告贴"
            value="7"
          ></el-option>
          <el-option
            v-if="circleForm?.tenantId == 492"
            label="找搭子帖"
            value="4"
          ></el-option>
          <el-option
            v-if="circleForm?.tenantId == 492"
            label="线上赛贴"
            value="5"
          ></el-option>
        </el-select>
        <el-input
          style="width: 32%"
          v-model="searchParams.auditor"
          placeholder="请输入审核人"
          clearable
        ></el-input>
        <el-input
          style="width: 32%"
          v-model="searchParams.contentLabelIds"
          placeholder="内容标签ID"
          clearable
        ></el-input>

        <el-date-picker
          style="width: 32%"
          v-model="searchParams.contributeTime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>

        <div class="button-group">
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </div>
      </div>
    </div>
    <div class="content-audit-tabel">
      <el-button
        class="import-btn"
        @click="handleMultiAudit"
        v-if="articleListCode == 1"
      >
        批量审批
      </el-button>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部" name="all">
          <span slot="label" class="slot-item">
            <span>全部</span>
            <!-- <span>{{ allCount }}</span> -->
          </span>
          <circle-table
            :tableData="tableData"
            @handleClick="TabhandleClick"
            :mulSelect="false"
          ></circle-table>
        </el-tab-pane>
        <el-tab-pane label="待审核" name="pending">
          <span slot="label" class="slot-item">
            <span>待审核</span>
            <!-- <span>{{ unAuditCount }}</span> -->
          </span>
          <div class="multiSelect" v-if="showMultiSelect">
            <div class="select-white">已选择</div>
            <div class="select-blue" style="color: #266cee">
              {{ this.selectedRows.length }}
            </div>
            <div class="select-white" style="margin-right: 20px">项</div>
            <el-button class="select-blue" @click="confirmMultiPass"
              >审核通过</el-button
            >
            <el-button class="select-blue" @click="confirmMultDeny"
              >审核拒绝</el-button
            >
          </div>

          <circle-table
            :tableData="tableData"
            @handleClick="TabhandleClick"
            @selectedRows="updateSelectedRows"
            ref="childTable"
            :mulSelect="true"
          ></circle-table>
        </el-tab-pane>
        <el-tab-pane
          label="复审"
          name="rejudge"
          v-if="circleForm?.tenantId == 492"
        >
          <span slot="label" class="slot-item">
            <span>复审</span>
            <!-- <span>{{ unAuditCount }}</span> -->
          </span>
          <div class="multiSelect" v-if="showMultiSelect">
            <div class="select-white">已选择</div>
            <div class="select-blue" style="color: #266cee">
              {{ this.selectedRows.length }}
            </div>
            <div class="select-white" style="margin-right: 20px">项</div>
            <el-button class="select-blue" @click="confirmMultiPass"
              >审核通过</el-button
            >
            <el-button class="select-blue" @click="confirmMultDeny"
              >审核拒绝</el-button
            >
          </div>

          <circle-table
            :tableData="tableData"
            @handleClick="TabhandleClick"
            @selectedRows="updateSelectedRows"
            ref="childTable"
            :mulSelect="true"
          ></circle-table>
        </el-tab-pane>
        <el-tab-pane label="审核通过" name="passed">
          <span slot="label" class="slot-item">
            <span>审核通过</span>
            <!-- <span>{{ passAuditCount }}</span> -->
          </span>
          <circle-table
            :tableData="tableData"
            @handleClick="TabhandleClick"
            :mulSelect="false"
          ></circle-table>
        </el-tab-pane>
        <el-tab-pane label="审核拒绝" name="offline">
          <span slot="label" class="slot-item">
            <span>审核拒绝</span>
            <!-- <span>{{ offlineCount }}</span> -->
          </span>
          <circle-table
            :tableData="tableData"
            @handleClick="TabhandleClick"
            :mulSelect="false"
          ></circle-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <pagination
      @sizePageChange="paginationChangeProduct"
      :paginationDatas="paginationDataProduct"
    ></pagination>
    <el-drawer
      :visible.sync="dialogSetCircle"
      direction="rtl"
      size="40%"
      :destroy-on-close="true"
    >
      <div class="header-container">
        <div class="header">帖子详情</div>
      </div>
      <div style="margin-top: 10px" class="form-container">
        <el-form
          :model="circleForm"
          :rules="circleRules"
          ref="circleForm"
          label-width="160px"
        >
          <!-- 帖子ID -->
          <el-form-item label="帖子ID">
            {{ circleForm.postId }}
          </el-form-item>

          <!-- 帖子审核状态 -->
          <el-form-item label="帖子状态">
            {{ circleForm.auditStatus == 0 ? "待审核" : null }}
            {{ circleForm.auditStatus == 1 ? "审核通过" : null }}
            {{ circleForm.auditStatus == 2 ? "审核拒绝" : null }}
          </el-form-item>

          <!-- 发布者 -->
          <el-form-item label="发布者">
            {{ circleForm.nickName }}
          </el-form-item>

          <!-- 发布者 -->
          <el-form-item label="用户pin">
            {{ circleForm.pin }}
          </el-form-item>

          <!-- 用户发布时间 -->
          <el-form-item label="发布时间">
            {{ formatDate(circleForm.submitTime) }}
          </el-form-item>

          <!-- 所属圈子名称 -->
          <el-form-item label="所属圈子" v-if="!communityOptionsVisible">
            {{ circleForm.communityName }}
            <el-button type="text" @click="communityOptionsShow(true)"
              >修改</el-button
            >
          </el-form-item>
          <el-form-item label="所属圈子" v-else>
            <el-select
              v-model="communityOptionsValue"
              filterable
              remote
              placeholder="请选择所属圈子"
              :remote-method="remoteMethod"
              clearable
              @focus="onClearSelect"
              @clear="onClearSelect"
            >
              <el-option
                v-for="item in communityOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-button type="text" @click="communityOptionsShow(false)"
              >取消</el-button
            >
            <el-button
              type="text"
              @click="communityOptionsConfirm"
              :loading="communityOptionsloading"
              >确认</el-button
            >
          </el-form-item>

          <!-- 帖子话题名称列表 -->
          <!-- <el-form-item label="用户关联话题">
            {{ circleForm?.topicNameList?.topicName }}
          </el-form-item> -->

          <!-- 帖子分级 -->
          <el-form-item label="帖子分级" v-if="!postLevelOptsShow">
            {{ postLevelMapList[circleForm?.postLevel] }}
            <el-button type="text" @click="handlePostLevelOptsShow(true)"
              >修改</el-button
            >
          </el-form-item>
          <el-form-item label="帖子分级" v-else>
            <el-select
              v-model="postLevelOptValue"
              placeholder="请选择帖子分级"
              clearable
              @focus="onPostSelect"
              @clear="onPostSelect"
            >
              <el-option label="未设置" :value="0"></el-option>
              <el-option label="D级" :value="1"></el-option>
              <el-option label="C级" :value="2"></el-option>
              <el-option label="B级" :value="3"></el-option>
              <el-option label="A级" :value="4"></el-option>
              <el-option label="S级" :value="5"></el-option>
            </el-select>
            <el-button type="text" @click="handlePostLevelOptsShow(false)"
              >取消</el-button
            >
            <el-button
              type="text"
              @click="postLevelOptsConfirm"
              :loading="postLevelOptsloading"
              >确认</el-button
            >
          </el-form-item>
          <!-- 圈子类型 -->
          <!-- <el-form-item label="圈子类型" >
            {{ circleForm.communityType }}
          </el-form-item> -->

          <!-- 标题 -->
          <el-form-item label="帖子标题">
            {{ circleForm.title }}
          </el-form-item>

          <!-- 正文 -->
          <el-form-item label="帖子正文">
            {{ circleForm.content }}
          </el-form-item>
          <el-divider></el-divider>
          <!-- 康康回复内容 -->
          <el-form-item label="康康回复内容">
            <div v-if="KKCommentInputShow">
              <el-input
                size="small"
                type="textarea"
                v-model="circleForm.kangkangComment"
                maxlength="200"
                show-word-limit
                class="freezeInp"
              >
              </el-input>
              <el-button type="text" @click="handleEditKKComment"
                >确认</el-button
              >
              <el-button
                type="text"
                @click="
                  () => {
                    this.KKCommentInputShow = false;
                    this.circleForm.kangkangComment = this.KKCommentTemp;
                    this.KKCommentTemp = '';
                  }
                "
                >取消</el-button
              >
            </div>
            <div v-else>
              {{ circleForm.kangkangComment }}
              <el-button
                type="text"
                @click="
                  () => {
                    this.KKCommentInputShow = true;
                    this.KKCommentTemp = this.circleForm.kangkangComment;
                  }
                "
                >修改</el-button
              >
            </div>
          </el-form-item>

          <!-- 康康追问 -->
          <el-form-item label="康康追问">
            <div v-if="KKQuestionInputShow">
              <el-input
                size="small"
                type="textarea"
                v-model="circleForm.kangkangQuestion"
                maxlength="200"
                show-word-limit
                class="freezeInp"
              >
              </el-input>
              <el-button type="text" @click="handleEditKKComment"
                >确认</el-button
              >
              <el-button
                type="text"
                @click="
                  () => {
                    this.KKQuestionInputShow = false;
                    this.circleForm.kangkangQuestion = this.KKQuestionTemp;
                    this.KKQuestionTemp = '';
                  }
                "
                >取消</el-button
              >
            </div>
            <div v-else>
              {{ circleForm.kangkangQuestion }}
              <el-button
                type="text"
                @click="
                  () => {
                    this.KKQuestionInputShow = true;
                    this.KKQuestionTemp = this.circleForm.kangkangQuestion;
                  }
                "
                >修改</el-button
              >
            </div>
          </el-form-item>

          <!-- 康康高亮词 -->
          <el-form-item label="康康高亮词">
            {{ circleForm.kangkangHighlightWords }}
          </el-form-item>
          <el-divider></el-divider>

          <!-- PK/投票帖 -->
          <el-form-item label="帖子类型">
            {{ circleForm?.communityPostType }}
          </el-form-item>

          <el-form-item
            label="PK/投票标题"
            v-if="circleForm?.communityPostType != '普通帖'"
          >
            {{ circleForm?.componentInfo?.title }}
          </el-form-item>

          <el-form-item
            label="PK/投票观点"
            v-if="circleForm?.communityPostType != '普通帖'"
          >
            <div
              v-for="(opinion, index) in circleForm?.componentInfo?.opinions"
              :key="opinion.opinionId"
              :style="{ marginLeft: index !== 0 ? '20px' : '0' }"
            >
              {{ opinion?.opinionTitle }}
            </div>
          </el-form-item>

          <el-form-item
            label="投票天数"
            v-if="circleForm?.communityPostType == '投票帖'"
          >
            {{ (circleForm?.componentInfo?.validDay || 0) + "天" }}
          </el-form-item>

          <el-form-item
            label="剩余天数"
            v-if="circleForm?.communityPostType == '投票帖'"
          >
            {{
              ((circleForm?.componentInfo?.status == 0
                ? circleForm?.componentInfo?.validDay
                : circleForm?.componentInfo?.remainingDay) || 0) + "天"
            }}
          </el-form-item>

          <el-form-item
            label="投票状态"
            v-if="circleForm?.communityPostType != '普通帖'"
          >
            {{ this.roteStatusMapList[circleForm?.componentInfo?.status] }}
          </el-form-item>

          <el-form-item
            label="投票结果"
            v-if="circleForm?.communityPostType != '普通帖'"
          >
            <div
              v-for="(opinion, index) in circleForm?.componentInfo?.opinions"
              :key="opinion.opinionId"
              :style="{ marginLeft: index !== 0 ? '20px' : '0' }"
            >
              <span>{{ opinion?.opinionTitle }}：{{ opinion?.joinCount }}</span>
              <span v-if="opinion?.ratio" :style="{ marginLeft: '20px' }"
                >占{{ (parseFloat(opinion?.ratio) * 100).toFixed(0) }}%</span
              >
            </div>
            <div :style="{ marginLeft: '20px' }">
              总人数：{{ circleForm?.componentInfo?.joinTotalCount }}
            </div>
          </el-form-item>
          <el-divider></el-divider>

          <!-- 小图 -->
          <el-form-item label="图文视频" label-width="160px" prop="imageUrl">
            <div class="image-flex" v-if="circleForm.contentPicUrl">
              <div
                v-for="(url, index) in JSON.parse(circleForm.contentPicUrl)"
                :key="index"
                class="image-item"
              >
                <img
                  :src="
                    url.startsWith(imgHost) ||
                    url.startsWith('http://storage.jd.local') ||
                    url.startsWith('https') ||
                    url.startsWith('http') ||
                    url.startsWith('https://jkimg10.360buyimg.com') ||
                    url.startsWith('https://storage.360buyimg.com')
                      ? url
                      : `${imgHost}${url}`
                  "
                  alt="图片"
                  @click="handleImageClick(url)"
                />
                <div class="image-overlay">
                  <el-button
                    @click="
                      viewImage(
                        url.startsWith(imgHost) ||
                          url.startsWith('http://storage.jd.local') ||
                          url.startsWith('https') ||
                          url.startsWith('http') ||
                          url.startsWith('https://jkimg10.360buyimg.com') ||
                          url.startsWith('https://storage.360buyimg.com')
                          ? url
                          : `${imgHost}${url}`
                      )
                    "
                    type="primary"
                    icon="el-icon-zoom-in"
                    size="mini"
                  ></el-button>
                </div>
              </div>
            </div>
            <div v-else>暂无图片</div>
            <div class="image-flex" v-if="circleForm.postVideoInfo">
              <video
                ref="videoPlayer"
                :src="circleForm.postVideoInfo.playUrl"
                controls
                style="width: 100%"
              ></video>
            </div>
          </el-form-item>
          <!-- 敏感 -->
          <el-form-item label="是否含敏感内容">
            {{
              circleForm?.postExtDTO?.sensitiveWordInfo ||
              circleForm?.postExtDTO?.isImageSensitiveWord ||
              circleForm?.postExtDTO?.isImagePorn
                ? "是"
                : "否"
            }}
          </el-form-item>
          <!-- 敏感内容 -->
          <el-form-item
            v-if="
              circleForm?.postExtDTO?.sensitiveWordInfo ||
              circleForm?.postExtDTO?.isImageSensitiveWord ||
              circleForm?.postExtDTO?.isImagePorn
            "
            label="所含敏感内容"
          >
            <div v-if="circleForm?.postExtDTO?.sensitiveWordInfo">
              <span>敏感词信息:</span>
              {{ circleForm?.postExtDTO?.sensitiveWordInfo }}
            </div>
            <div
              v-if="circleForm?.postExtDTO?.isImageSensitiveWord"
              style="margin-left: 20px"
            >
              <span>图片包含敏感词:</span>
              {{ circleForm?.postExtDTO?.isImageSensitiveWord ? "是" : "否" }}
            </div>
            <div
              v-if="circleForm?.postExtDTO?.isImagePorn"
              style="margin-left: 20px"
            >
              <span>图片包含涉黄信息:</span>
              {{ circleForm?.postExtDTO?.isImagePorn ? "是" : "否" }}
            </div>
          </el-form-item>
          <el-divider></el-divider>
          <el-form-item label="额外内容" v-if="circleForm?.tenantId == 492">
            <div
              style="
                width: 90%;
                overflow-wrap: break-word;
                word-break: break-word;
                white-space: normal;
              "
            >
              {{ circleForm?.appendInfo }}
            </div>
            <el-radio-group
              v-if="
                circleForm.auditStatus == 4 &&
                circleForm?.communityPostType == '线上赛帖'
              "
              v-model="jdGoStatus"
            >
              <el-radio :label="1">优质</el-radio>
              <el-radio :label="2">低质</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="额外内容" v-if="circleForm?.tenantId == 524">
            <div
              style="
                width: 90%;
                overflow-wrap: break-word;
                word-break: break-word;
                white-space: normal;
              "
            >
              <!-- 使用 v-for 遍历 labels 数组 -->
              <template
                v-if="JSON.parse(circleForm?.appendInfo || '{}')?.labels"
              >
                <div>帖子标签</div>
                <div
                  v-for="(item, index) in JSON.parse(
                    circleForm?.appendInfo || '{}'
                  ).labels"
                  :key="index"
                >
                  <div>标签名称: {{ item.labelName }}</div>
                  <div>是否为用户定义: {{ item.customize ? "是" : "否" }}</div>
                  <div>标签id: {{ item.labelId }}</div>
                  <el-divider></el-divider>
                </div>
              </template>
              <template
                v-if="
                  JSON.parse(circleForm?.appendInfo || '{}')?.postPublishSkuInfo
                "
              >
                <div>SKU信息</div>
                <div>
                  SKUID:
                  {{
                    JSON.parse(circleForm?.appendInfo || "{}")
                      ?.postPublishSkuInfo?.skuId
                  }}
                </div>
                <div>
                  SKU名称:
                  {{
                    JSON.parse(circleForm?.appendInfo || "{}")
                      ?.postPublishSkuInfo?.skuName
                  }}
                </div>
                <div>
                  商品主图:
                  <el-image
                    :src="
                      JSON.parse(circleForm?.appendInfo || '{}')
                        ?.postPublishSkuInfo?.skuPic || ''
                    "
                  />
                </div>
                <el-divider></el-divider>
              </template>
              <template v-if="circleForm?.componentInfo">
                <div>互动信息</div>
                <div>
                  参与人数: {{ circleForm?.componentInfo?.joinTotalCount }}
                </div>
                <div>
                  赞数:
                  {{ circleForm?.componentInfo?.opinions?.[0]?.joinCount }}
                </div>
                <div>
                  踩数:
                  {{ circleForm?.componentInfo?.opinions?.[1]?.joinCount }}
                </div>
              </template>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="drawer-footer">
        <el-button
          @click="
            dialogSetCircle = false;
            jdGoStatus = 2;
          "
          >关闭</el-button
        >
        <el-button
          v-if="circleForm.auditStatus !== 2"
          @click="confirmSingleDeny(circleForm.postId)"
          >审核拒绝</el-button
        >
        <el-button
          v-if="circleForm.auditStatus !== 1"
          type="primary"
          @click="confirmSinglePass(circleForm.postId)"
          >审核通过</el-button
        >
      </div>
    </el-drawer>
    <!-- 图片放大展示 -->
    <el-dialog :visible.sync="dialogVisible" width="50%">
      <img :src="currentImageUrl" alt="图片" style="width: 100%" />
    </el-dialog>
  </div>
</template>

<script>
import utils from "../../../../../utils";
import { getBusinessId } from "../../../../../utils/enum";
import circleTable from "./circleTable.vue";
import { videoPlayer } from "vue-video-player";
// import search from "../../../components/search"
import manFormList from "../../../components/manFormList";
import breadCrumb from "../../../../../components/breadCrumb";
import pagination from "../../../../../components/pagination";
import diseaseLabel from "@/components/diseaseLabel";
import {
  getAllArticleCounts,
  setArticleBadgeStatus,
  passOfflineArticle,
  rejectOfflineArticle,
  manOfflineArticle,
  listContentBusinessForUserMan,
  manSaveUserConfig,
  manListUserConfig,
  jdh_qz_man_post_types,
} from "@/api/man";
import { jdh_qz_man_post_page } from "../../../../../api/community";
import { jdh_qz_man_post_top } from "../../../../../api/community";
import { jdh_qz_man_add_post_top } from "../../../../../api/community";
import { jdh_qz_man_add_post_featured } from "../../../../../api/community";
import { jdh_qz_man_cancel_post_top } from "../../../../../api/community";
import { jdh_qz_man_cancel_post_featured } from "../../../../../api/community";

import { jdh_qz_man_post_batch_audit } from "../../../../../api/community";
import { jdh_qz_man_post_batch_update_level } from "../../../../../api/community";

// import {queryCommunityList} from "../../../../../api/community";
import modal from "@/components/modal";
import baseDialog from "../../../components/baseDialog";
import { getDiseasesData } from "../distribution";
import { request } from "@/utils/axios";
import {
  getDistributionScope,
  searchDataProcessing,
  getContentQuailty,
  getGeneralLabel,
  getContentSources,
} from "../distribution";
import {
  manListContentIndexTree,
  qzManPage,
  changeCommunity,
  changeKKComment,
  subject_auditPostQuality,
} from "@/api/indexs";
import {
  getOutArticleCategory,
  uploadCategoryExl,
  fileChange,
} from "../../../components/importExportCommon";
import { getImportTemplate } from "@/api/man";
import { mapState } from "vuex";
import uploadImage from "@/components/uploadImage";
import uploadPosterImage from "@/components/upload/uploadPosterImage";
import uploadImgUniversal from "@/components/upload/uploadImgUniversal";
import GenericNameLabel from "@/components/combination/GenericNameLabel";
import UploadVideo from "@/components/combination/UploadVideo";
import { MessageBox, Message } from "element-ui";

var selectList_bak = {
  articleId: "", //文章ID
  articleKeyWord: "", // 文章关键字
  diseaseLabel: "", // 疾病圈标签
  nickname: "", // 写手昵称
  writerPin: "", // 写手Pin
  doctorName: "", // 医生名字
  hospital: "", // 医院名称
  department: "", // 科室名称
  articleType: "", // 文章类型
  submissionTime: [], // 投稿时间
  auditTime: [], //
  featuredArticle: "", // 精选文章
  isOriginal: "", // 是否原创
  isTop: "", // 是否置顶
  business: [], // 所属业务
  categoryId: "", // 所属栏目
  channelId: "", // 所属频道
  categoryRelationId: "", // 类目ID
  range: "", // 分发范围
  quality: "", // 内容质量
  contentDiseasesNotNull: "",
  isDoctor: "",
  contentIndexIds: [], // 索引
  questionSource: null, // 问题来源
  videoType: "",
  videoDuration: {
    startNum: "",
    endNum: "",
  }, // 视频时长
  videoText: {
    startNum: "",
    endNum: "",
  }, // 视频正文
};
export default {
  name: "circleManage",
  data() {
    return {
      postTypeMap: {},
      num: 3,
      rejectForm: {
        rejectlineDialog: false,
        rejectReasons: "",
        applyReason: "",
        isShowBtn: [true, true], //弹窗是否能显示按钮
        ordinaryBtnText: ["取消", "确认"],
      },
      activeName: "all",
      selectedRows: [],
      tableData: {
        tableList: [],
        tableHeader: [
          {
            label: "帖子ID",
            prop: "postId",
            width: "100px",
          },
          {
            label: "帖子名称",
            prop: "title",
            width: "150px",
          },
          {
            label: "帖子正文",
            prop: "content",
            width: "150px",
          },
          {
            label: "所属圈子",
            prop: "communityName",
          },
          // {
          //   label: '用户关联话题',
          //   prop: 'topicList',
          //   width: "80px"
          // },
          {
            label: "帖子类型",
            prop: "communityPostType",
            width: "80px",
          },
          {
            label: "发布者",
            prop: "nickName",
          },
          {
            label: "发布者id",
            prop: "pin",
          },
          {
            label: "帖子状态",
            prop: "auditStatusCheck",
          },
          {
            label: "分级",
            prop: "postLevel",
            width: "150px",
          },
          {
            label: "发布时间",
            prop: "submitTime",
          },
          {
            label: "审核人",
            prop: "auditor",
          },
        ],
        // 111: 健康app
        // 112: 夜谜
        tableType:
          this.$route.query.tenantid == 287 || this.$route.query.tenantid == 290
            ? 112
            : 111,
      },
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      articleStatus: [],
      articleListCode: 0,
      allCount: 0, // 全部
      offlineCount: 0, // 已下线
      offlineUnAuditCount: 0, // 下线待审核
      passAuditCount: 0, // 已通过
      rejectCount: 0, // 驳回
      unAuditCount: 0, // 待审核
      isShowBtn: [true, true, false],
      reviewOfflineDialog: false, // 审核下线申请
      btnText: ["驳回", "通过"],
      targetValue: null,
      isSelected: false,
      offlineDialogShow: false,
      formlist: [],
      selectList: this.$commonJs.deepClone(selectList_bak),
      reasonFrom: {
        seeReasonDialog: false,
        ordinaryBtnText: ["取消", "确认"],
        isShowBtn: [true, true], //弹窗是否能显示按钮
        reason: "",
      },
      old: {},
      isBtn: 1,
      isShowFilter: 1,
      searchFilterList: [],
      configId: null,
      checkList: [1000],
      allSearchList: [],
      serverList: [],
      contentAttributes: [],
      rangeList: [], // 分发范围
      qualityList: [], // 内容质量
      businessList: [],
      articleLabels: [], // 内容标签
      businessChannelArr: [],
      isButton: false,
      uploadShow: false,
      timer: null,
      // 新建圈子
      dialogSetCircle: false,
      // 增加主视频
      dialogAddVideo: false,
      // ------------------- 批量导入 end ---------------------
      circleForm: {
        businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
        title: "",
        hotValue: "",
        content: "",
        communityType: "",
        pin: "",
        contentPicUrlList: [],
        contentPicUrl: "",
        isTopicTop: "",
        communityName: "",
        communityId: "",
        class: "",
        avatarUrl: "",
        nickName: "",
        auditor: "",
        updateUser: "",
        updateTime: "",
        postId: "",
        submitTime: "",
        isCommunityTop: "",
        auditTime: "",
        createTime: "",
        tenantId: parseInt(this.$route.query.tenantid),
        authorIp: "",
        auditStatus: "",
        createUser: "",
        isAutoAudit: "",
        status: "",
        realyName: "",
        kangkangComment: "",
        kangkangQuestion: "",
        kangkangHighlightWords: "",
      },
      circleRules: {
        // name: [
        //   { required: true, message: '请输入圈子名称', trigger: 'blur' }
        // ],
        // imageUrl: [
        //   { required: true, message: '请上传圈子小图', trigger: 'change' }
        // ],
        // type: [
        //   { required: true, message: '请选择圈子类型', trigger: 'change' }
        // ],
        // features: [
        //   { required: true, type: 'array', min: 1, message: '请选择至少一个功能', trigger: 'change' }
        // ]
      },
      additionalFeatures: ["视频", "圈子", "问医生", "推荐好物"],
      circlePlaceholders: {
        视频: "请输入关键词，多个关键词‘;‘隔开",
        问医生: "请输入医生搜索关键词",
        推荐好物: "请输入商品搜索关键词",
      },
      titlePicUrl: [],
      dialogVisible: false,
      searchParams: {
        communityName: "",
        communityIds: this.$route.query.circleId || "",
        communityType: "",
        auditStatus: "",
      },
      showMultiSelect: false,
      communityOptions: [],
      communityOptionsValue: null,
      communityOptionsVisible: false,
      communityOptionsloading: false,
      postLevelOptValue: 0,
      postLevelOptsShow: false,
      postLevelOptsloading: false,
      KKCommentInputShow: false,
      KKQuestionInputShow: false,
      KKCommentTemp: "",
      KKQuestionTemp: "",
      globalTenantId: this.$route.query.tenantid,
      globalBusinessId: this.getBusinessId(
        parseInt(this.$route.query.tenantid)
      ),
      postLevelMapList: ["未设置", "D级", "C级", "B级", "A级", "S级"],
      roteStatusMapList: ["未开始", "进行中", "已结束"],
      jdGoStatus: 2,
    };
  },
  components: {
    // search,
    manFormList,
    breadCrumb,
    circleTable,
    pagination,
    modal,
    baseDialog,
    uploadPosterImage,
    uploadImage,
    uploadImgUniversal,
    GenericNameLabel,
    UploadVideo,
    videoPlayer,
  },
  async created() {
    // console.log('开始=========》');
    // 查询用户保存配置
    await this.queryUserConfig();
    //  获取天空之城数据
    await this.queryFloorList();
    //  console.log('结束=========》');
    // 获取分发范围
    // this.getDistributionScope();
    // 获取内容质量
    // this.getContentQuailty();
    // 是否由文章详情页跳转本页面
    // this.initializeJump()
    // sessionStorage获取tabpane的状态
    this.getSessionStorageInfo();
    // this.getArticleList()
    this.listContentBusinessForUserMan();
    // 获取标签
    this.getGeneralLabel();
    debugger;
    console.log(22222);
    // 获取圈子select
    this.getCommunitySelect();
    getContentSources(this);
    if (this.$route.query.circleId) {
      const circleId = this.$route.query.circleId;
      this.handleInitSearch(circleId);
    }
    this.getPostType();
  },
  mounted() {
    this.$nextTick(() => {
      // 添加这段代码
      const $el = document.querySelectorAll(
        ".el-cascader-panel .el-cascader-node[aria-owns]"
      );
      Array.from($el).map((item) => item.removeAttribute("aria-owns"));
    });
  },
  destroyed() {
    // 销毁详情跳跳转存储
    sessionStorage.removeItem("content");
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  computed: {
    ...mapState(["imgHost", "userInfo"]),
  },
  methods: {
    getPostType() {
      jdh_qz_man_post_types({}).then((ret) => {
        let keyMap = {};
        console.log(ret, "课程ret");
        ret.forEach((item, index) => {
          keyMap[item?.value] = item?.label;
        });
        this.postTypeMap = keyMap;
      });
    },
    // 获取圈子select
    getCommunitySelect() {
      qzManPage({
        pageNo: 1,
        pageSize: 100, // 后端设定 夜迷不可能超过100 后期优化非分页
        tenantId: parseInt(this.$route.query.tenantid),
        businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
        status: 1,
      }).then((res) => {
        console.log("qzManPage", res);
        this.communityOptions = (res.data || [])?.map((item) => ({
          value: item.communityId,
          label: item.communityName,
        }));
        console.log("getCommunitySelect", res);
      });
    },
    getCommunityPostType(type) {
      // jdh_qz_man_post_types({}).then((ret) => {
      //   console.log(ret, "帖子类型");
      // });
      const typeEnum = {
        1: "普通帖",
        2: "PK帖",
        3: "投票帖",
        4: "找搭子帖",
        5: "线上赛帖",
        6: "课程贴",
        7: "广告贴",
      };
      return typeEnum?.[type] || "普通帖";
    },
    communityOptionsShow(show) {
      this.communityOptionsVisible = show;
    },
    handlePostLevelOptsShow(show) {
      console.log("==== postLevelOptsShow", show);
      if (show) {
        this.postLevelOptValue = this.circleForm.postLevel || 0;
      }
      this.postLevelOptsShow = show;
    },
    communityOptionsConfirm() {
      console.log(this.circleForm);
      if (!this.communityOptionsValue) {
        this.$message({
          message: "请选择所属圈子",
          type: "warning",
        });
        return;
      }
      this.communityOptionsloading = true;
      try {
        changeCommunity({
          targetCommunityId: this.communityOptionsValue,
          postIds: [this.circleForm.postId],
          tenantId: parseInt(this.$route.query.tenantid),
          businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
        })
          .then((res) => {
            console.log(res);
            if (res) {
              this.communityOptions.map((item) => {
                console.log(item);
                if (item.value === this.communityOptionsValue) {
                  this.circleForm.communityName = item.label;
                }
              });
              this.communityOptionsVisible = false;
              this.getArticleList();
            } else {
              this.$message({
                message: "失败",
                type: "error",
              });
            }
          })
          .catch((err) => {
            console.log("err", err);
            this.$message({
              message: err.msg || "失败",
              type: "error",
            });
          });
        this.communityOptionsloading = false;
      } catch (err) {
        console.log("err", err);
        this.$message({
          message: "失败",
          type: "error",
        });
        this.communityOptionsloading = false;
      }
    },
    postLevelOptsConfirm() {
      console.log(this.circleForm);
      if (
        this.postLevelOptValue == null ||
        this.postLevelOptValue == undefined
      ) {
        this.$message({
          message: "请选择分级",
          type: "warning",
        });
        return;
      }
      this.postLevelOptsloading = true;
      try {
        jdh_qz_man_post_batch_update_level({
          tenantId: parseInt(this.$route.query.tenantid),
          businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
          updateInfo: [
            {
              postId: this.circleForm.postId,
              postLevel: this.postLevelOptValue,
            },
          ],
        })
          .then((res) => {
            console.log(res);
            if (res) {
              this.postLevelOptsShow = false;
              this.circleForm.postLevel = this.postLevelOptValue;
              this.getArticleList();
            } else {
              this.$message({
                message: "失败",
                type: "error",
              });
            }
          })
          .catch((err) => {
            console.log("err", err);
            this.$message({
              message: err.msg || "失败",
              type: "error",
            });
          });
        this.postLevelOptsloading = false;
      } catch (err) {
        console.log("err", err);
        this.$message({
          message: "失败",
          type: "error",
        });
        this.postLevelOptsloading = false;
      }
    },
    handleEditKKComment() {
      console.log("==== kangkangQuestion", this.circleForm.kangkangQuestion);
      console.log("==== kangkangComment", this.circleForm.kangkangComment);
      changeKKComment({
        postId: this.circleForm.postId,
        comment: this.circleForm.kangkangComment,
        question: this.circleForm.kangkangQuestion,
      })
        .then(() => {
          this.KKCommentInputShow = false;
          this.KKQuestionInputShow = false;
          this.$message.success(`修改成功`);
          this.getArticleList();
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    // 跳转存储信息
    setStorage() {
      // 跳转页面存储当前页码
      sessionStorage.setItem(
        "currentPage",
        this.paginationDataProduct.currentPage
      );
      sessionStorage.setItem("activeName", this.activeName);
      let selectStr = JSON.stringify(this.selectList);
      let selectList = JSON.stringify(this.select);
      sessionStorage.setItem("selectList", selectList);
      sessionStorage.setItem("select", selectStr);
    },
    getSessionStorageInfo() {
      this.activeName = sessionStorage.getItem("activeName") || "all";
      if (this.activeName === "all") {
        this.articleListCode = 0;
        this.searchParams.auditStatusCheck = "";
      } else if (this.activeName === "pending") {
        this.articleListCode = 2;
        this.searchParams.auditStatusCheck = 0;
      } else if (this.activeName === "passed") {
        this.articleListCode = 3;
        this.searchParams.auditStatusCheck = 1;
      } else if (this.activeName === "offline") {
        this.articleListCode = 5;
        this.searchParams.auditStatusCheck = 2;
      } else {
        console.log("==== error", this.activeName);
        this.activeName = "all";
        this.articleListCode = 0;
        this.searchParams.status = "";
      }
      this.articleStatus = [];
      if (this.articleListCode !== 0) {
        this.articleStatus.push(this.articleListCode);
      }
      this.getArticleList();
    },
    // 切换tab
    handleClick(tab, event) {
      sessionStorage.setItem("activeName", tab.name);
      this.paginationDataProduct = {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      };
      // this.getArticleList()
      if (this.activeName === "all") {
        this.articleListCode = 0;
        this.searchParams.auditStatusCheck = "";
      } else if (this.activeName === "pending") {
        this.articleListCode = 1;
        this.searchParams.auditStatusCheck = 0;
      } else if (this.activeName === "passed") {
        this.articleListCode = 2;
        this.searchParams.auditStatusCheck = 1;
      } else if (this.activeName === "offline") {
        this.articleListCode = 3;
        this.searchParams.auditStatusCheck = 2;
      } else if (this.activeName === "rejudge") {
        this.articleListCode = 3;
        this.searchParams.auditStatusCheck = 4;
      }
      this.articleStatus = [];
      if (this.articleListCode !== 0) {
        this.articleStatus.push(this.articleListCode);
      }
      this.getArticleList();
    },
    // 操作逻辑
    TabhandleClick(val) {
      if (val.type === "edit") {
        this.setStorage();
        // 打开编辑弹窗
        this.dialogSetCircle = true;
      } else if (val.type === "check") {
        this.setStorage();
        console.log("========", val.val);
        this.circleForm = val.val;
        this.dialogSetCircle = true;
        this.communityOptionsValue = null;
        this.communityOptionsVisible = false;
        this.communityOptionsloading = false;
        (this.postLevelOptValue = 0),
          (this.postLevelOptsShow = false),
          (this.postLevelOptsloading = false),
          (this.KKCommentInputShow = false);
        this.KKQuestionInputShow = false;
        this.KKCommentTemp = "";
        this.KKQuestionTemp = "";
        // this.circleForm.communityPicUrl = url.replace(imgHost, "");
      } else if (val.type === "postpass") {
        // 审核通过
        // val.val.badge === 1 ? this.setArticleBadgeStatus(2, val.val.id) : this.setArticleBadgeStatus(1, val.val.id);
        this.confirmSinglePass(val.val.postId);

        // this.getArticleList()
      } else if (val.type === "postdeny") {
        // 审核拒绝
        this.confirmSingleDeny(val.val.postId);
      } else if (val.type === "posttop") {
        // 置顶
        if (this.globalTenantId == 484 || this.globalTenantId == 492) {
          // 夜谜置顶
          jdh_qz_man_post_top({
            postId: val.val.postId,
            businessId: this.getBusinessId(
              parseInt(this.$route.query.tenantid)
            ),
            tenantId: parseInt(this.$route.query.tenantid),
            preSetTop: val.val.preSetTop ^ 1,
          }).then(() => {
            this.getArticleList();
          });
        } else if (this.globalTenantId == 290 || this.globalTenantId == 287) {
          // 健康APP置顶
          val.val.isAppTop
            ? jdh_qz_man_cancel_post_top({
                postId: val.val.postId,
                businessId: this.getBusinessId(
                  parseInt(this.$route.query.tenantid)
                ),
                tenantId: parseInt(this.$route.query.tenantid),
                communityId: val.val.communityId,
              }).then(() => {
                this.getArticleList();
              })
            : jdh_qz_man_add_post_top({
                postId: val.val.postId,
                businessId: this.getBusinessId(
                  parseInt(this.$route.query.tenantid)
                ),
                tenantId: parseInt(this.$route.query.tenantid),
                communityId: val.val.communityId,
                communityType: val.val.communityType,
              }).then(() => {
                this.getArticleList();
              });
        }
      } else if (val.type === "postFeatured") {
        // 加精
        if (this.globalTenantId == 484 || this.globalTenantId == 492) {
          // 夜谜加精
          jdh_qz_man_post_top({
            postId: val.val.postId,
            businessId: this.getBusinessId(
              parseInt(this.$route.query.tenantid)
            ),
            tenantId: parseInt(this.$route.query.tenantid),
            isFreatured: val.val.isFreatured ^ 1,
          }).then(() => {
            this.getArticleList();
          });
        } else if (this.globalTenantId == 290 || this.globalTenantId == 287) {
          // 健康app加精
          val.val.isAppFeatured
            ? jdh_qz_man_cancel_post_featured({
                postId: val.val.postId,
                businessId: this.getBusinessId(
                  parseInt(this.$route.query.tenantid)
                ),
                tenantId: parseInt(this.$route.query.tenantid),
                communityId: val.val.communityId,
                communityType: val.val.communityType,
              }).then(() => {
                this.getArticleList();
              })
            : jdh_qz_man_add_post_featured({
                postId: val.val.postId,
                businessId: this.getBusinessId(
                  parseInt(this.$route.query.tenantid)
                ),
                tenantId: parseInt(this.$route.query.tenantid),
                communityId: val.val.communityId,
                communityType: val.val.communityType,
              }).then(() => {
                this.getArticleList();
              });
        }
      }
      this.getTargetValue(val.val);
      this.getArticleList();
    },
    paginationChangeProduct(val) {
      this.paginationDataProduct = val;
      this.getArticleList("pageChange");
    },
    //获取文章列表
    getArticleList(type) {
      console.log(this.selectList, "pppppppppppp");
      if (this.selectList.range != "" || this.selectList.quality != "") {
        this.searchDataProcessing();
      }
      let arr = [];
      if (this.selectList.articleLabel) {
        this.selectList.articleLabel.map((item) => {
          arr.push(item[item.length - 1]);
        });
      }
      console.log(
        this.selectList.videoText.startNum,
        "videoTextStartNum",
        this.selectList.videoText,
        this.selectList.videoDuration
      );
      // debugger
      let searchArticleTypes = [];
      //bugfix:文章类型必须是数组 否则接口报错
      console.log(this.selectList.actionType);
      this.selectList.articleType && this.selectList.articleType != "全部"
        ? searchArticleTypes.push(this.selectList.articleType)
        : "";
      const contentIndexIds =
        this.selectList?.contentIndexIds?.map(
          (item) => item[item?.length - 1]
        ) || [];
      let params = {
        tenantId: parseInt(this.$route.query.tenantid),
        pageNo: this.paginationDataProduct.currentPage,
        pageSize: this.paginationDataProduct.pageSize,
        businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
        title: this.searchParams.title,
        auditStatus:
          this.searchParams.auditStatusCheck !== undefined
            ? this.searchParams.auditStatusCheck
            : "",
        postIds: this.searchParams.postIds,
        communityIds: this.searchParams.communityIds,
        titleSearchKeyword: this.searchParams.titleSearchKeyword,
        contentSearchKeyword: this.searchParams.contentSearchKeyword,
        postLevelList: this.searchParams.postLevelList,
        communityPostTypes: this.searchParams.communityPostType,
        auditor: this.searchParams.auditor,
        authorPin: this.searchParams.authorPin,
        contentLabelIds: this.searchParams?.contentLabelIds?.trim()
          ? this.searchParams.contentLabelIds?.split(",")
          : [],
        beginTime: utils.isEmpty(this.searchParams.contributeTime)
          ? null
          : utils.timetamp(Number(this.searchParams.contributeTime[0])), // 开始时间
        endTime: utils.isEmpty(this.searchParams.contributeTime)
          ? null
          : utils.timetamp(Number(this.searchParams.contributeTime[1])), // 结束时间
      };
      console.log("==========PARAM", params);
      jdh_qz_man_post_page(params).then((res) => {
        this.tableData.tableList.splice(0, this.tableData.tableList.length);
        res.data.map((item) => {
          item.submitTime = this.formatDate(item.submitTime);
          if (item.auditStatus == 0) {
            item.auditStatusCheck = "待审核";
          } else if (item.auditStatus == 1) {
            item.auditStatusCheck = "审核通过";
          } else if (item.auditStatus == 2) {
            item.auditStatusCheck = "审核拒绝";
          }
          item.communityPostType = this.getCommunityPostType(
            item?.communityPostType
          );
          this.tableData.tableList.push(item);
        });
        this.paginationDataProduct.total = res.totalCount;
        this.paginationDataProduct.currentPage = res.pageNo;
        this.paginationDataProduct.pageSize = res.pageSize;
        console.log(
          "???",
          res.data,
          this.tableData,
          this.tableData.tableList[1]
        );
      });
      // 获取各个审核状态的文章的数量
      getAllArticleCounts(params).then((res) => {
        this.allCount = res.allCount;
        this.unAuditCount = res.unAuditCount;
        this.passAuditCount = res.passAuditCount;
        this.rejectCount = res.rejectCount;
        this.offlineCount = res.offlineCount;
        this.offlineUnAuditCount = res.offlineUnAuditCount;
      });
    },
    getTargetValue(target) {
      this.targetValue = target;
    },
    //查询当前运营所有的业务
    listContentBusinessForUserMan() {
      listContentBusinessForUserMan({
        tenantId: this.$commonJs.getTenantId(),
      }).then((res) => {
        res?.contentBusinesses?.forEach((item) => {
          // 改版注掉f
          // this.select[13].List.push({
          //   label: item.name,
          //   value: item.id
          // })
          this.businessList.push({
            label: item.name,
            value: item.id,
          });
          this.select.map((subItem) => {
            if (subItem.prop == "business" && subItem.cfgID == 4000) {
              subItem.List.push({
                label: item.name,
                value: item.id,
              });
            }
            return subItem;
          });
        });
      });
    },
    getGeneralLabel() {
      getGeneralLabel(this);
    },
    // 获取天空之城数据 生成页面数据
    async queryFloorList() {
      // console.log('queryFloorList=======>', 33333);
      await request("jdh_laputa_queryFloorList", {
        functionId: "contentReviewOnOffLine",
        appId: "21557c5d3d0a4ec1b0184719022bb4b5",
        osName: "jdhwiki",
        venderId: null,
        inquiryTenancyId: null,
        version: 5,
      })
        .then(async (res) => {
          // this.floorTransferDTOS = res?.cf?.floorTransferDTOS;
          // console.log(res?.cf?.floorTransferDTOS[0], 'contentAudit<----来了哥----->');
          //  处理天空之城数据
          const cfgArray = res?.cf?.floorTransferDTOS[0].cfgList.filter(
            (item) => {
              if (item?.name == "manuDataCfg" && item?.checkbox == "common") {
                return true;
              }
              return false;
            }
          );
          // console.log(cfgArray, 'contentAudit<----来了哥----->cfgArray');
          // 整体配置数据
          let valueArray = JSON.parse(cfgArray[0].value).map((item) => {
            return JSON.parse(item?.value);
          });
          let fileterArray = [];
          let allShowSearchArr = [];
          // 所有配置的数据 包括 ids
          valueArray.map((item) => {
            let filerItem = this.$commonJs.deepClone(item);
            if (!Array.isArray(filerItem?.selectedIDs)) {
              // 获取搜索筛选总的展示
              filerItem.selectItems = filerItem?.selectItems.filter(
                (subItem) => {
                  return subItem.isShow;
                }
              );
              fileterArray.push(filerItem);

              item.selectItems = item?.selectItems.map((subItem) => {
                if (subItem.cfgID == 4000) {
                  this.businessChannelArr.push(subItem);
                }
                return subItem;
              });
              allShowSearchArr.push(item);
            } else {
              if (this.serverList?.length == 0) {
                // console.log('默认id', 'itemSelectedIDs========>');
                this.checkList = item?.selectedIDs;
              }
            }
          });

          // console.log(valueArray ,fileterArray, 'valueArray=====>|||||allShowSearchArr',allShowSearchArr);
          this.allSearchList = allShowSearchArr;
          // 搜索筛选弹框展示的数据
          this.searchFilterList = fileterArray;
          // console.log(valueArray, '拿到我配置的数据');

          // 页面上展示搜索
          let tempSelectList = [];
          this.checkList?.map((cItem) => {
            allShowSearchArr.map((item) => {
              item?.selectItems?.map((subItem) => {
                if (cItem == subItem.cfgID) {
                  tempSelectList.push(subItem);
                }
              });
            });
          });
          // 显示的搜索弹框
          this.select = tempSelectList;
          // console.log(res, 'queryFloorList=====>|||||');
        })
        .catch((err) => {
          this.$message.error(err.msg || "查询失败");
        });
      // console.log('queryFloorList=======>', 44444);
    },
    // 查询用户配置
    async queryUserConfig() {
      // console.log('queryUserConfig=======>', 11111);
      await manListUserConfig({
        tenantId: this.$commonJs.getTenantId(),
        configCode: "1",
        sceneCode: "1",
      }).then((res) => {
        if (res && res?.length > 0) {
          const userConfigBizDTO = res[0];
          this.configId = userConfigBizDTO?.configId;
          // console.log(this.configId,userConfigBizDTO, 'configId=====>',userConfigBizDTO?.value.split(','));
          this.checkList = userConfigBizDTO?.value
            .split(",")
            .map((item) => parseInt(item));
          this.serverList = userConfigBizDTO?.value
            .split(",")
            .map((item) => parseInt(item));
        }
        console.log("queryUserConfig=======>", res);
      });
      // console.log('queryUserConfig=======>', 222222);
    },
    // 用户保存配置
    async saveUserConfig(body) {
      await manSaveUserConfig(body).then((res) => {
        console.log(res, "用户保存了==========>");
      });
    },
    setCircle() {
      console.log("SETCIRCLE");
      this.dialogSetCircle = true;
    },
    changeTitlePic(data) {
      // data-封面组件的返回值
      this.titlePicUrl = data;
      // this.circleForm.imageUrl = data
      if (this.titlePicUrl && this.titlePicUrl.length > 0) {
        let url = this.titlePicUrl[0].url;
        // url 要截去的那部分 这个要从环境变量中取
        const imgHost = process.env.VUE_APP_imgHost;
        this.circleForm.imageUrl = url.replace(imgHost, "");
      } else {
        this.circleForm.imageUrl = "";
      }
    },
    updateSelectedRows(rows) {
      console.log("!!!!", rows);
      this.selectedRows = rows;
    },
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      const pad = (n) => n.toString().padStart(2, "0");
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
        d.getDate()
      )} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    auditStatusText(status) {
      switch (status) {
        case 0:
          return "待审核";
        case 1:
          return "审核通过";
        case 2:
          return "审核拒绝";
        default:
          return "未知状态";
      }
    },
    changeTitlePic(newImageUrl) {
      this.circleForm.imageUrl = newImageUrl;
    },
    deleteImage(index) {
      this.circleForm.imageUrl.splice(index, 1);
    },
    viewImage(url) {
      this.currentImageUrl = url;
      this.dialogVisible = true;
    },
    handleMultiAudit() {
      this.$refs.childTable.selectAllRows();
      this.showMultiSelect = true;
    },
    confirmMultiPass() {
      if (this.selectedRows && this.selectedRows.length !== 0) {
        MessageBox.confirm("确定要批量审核通过选中的帖子吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.handleMultiPass();
            this.$message.success("已批量审核");
          })
          .then(() => {
            this.getArticleList();
          })
          .catch(() => {
            this.$message("已取消批量审核");
          });
      } else {
        this.$message.error("请先选择帖子");
      }
    },
    confirmSinglePass(data) {
      MessageBox.confirm("确定要审核通过选中的帖子吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.handleSinglePass(data);
        })
        .then(() => {
          this.getArticleList();
        })
        .catch(() => {
          ElMessage({
            type: "info",
            message: "已取消批量审核",
          });
        });
    },
    handleMultiPass() {
      // 初始化一个空数组 postIds 用于存储每个 post 的 postId
      const postIds = [];

      // 遍历 posts 数组，提取每个 post 的 postId 并放入 postIds 数组中
      this.selectedRows.forEach((post) => {
        postIds.push(post.postId);
      });

      // 创建一个包含 postIds 和 targetAuditStatus 的对象 params
      const params = {
        postIds: postIds,
        targetAuditStatus: 1,
        status: 1,
        businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
        tenantId: parseInt(this.$route.query.tenantid),
      };

      jdh_qz_man_post_batch_audit(params)
        .then((res) => {
          this.$message({
            message: res ? "审核成功" : "审核失败",
            type: "success",
          });
        })
        .then(() => {
          this.getArticleList();
        });
    },
    handleSinglePass(data) {
      // 初始化一个空数组 postIds 用于存储每个 post 的 postId
      const postIds = [];
      postIds.push(data);

      // 创建一个包含 postIds 和 targetAuditStatus 的对象 params
      const params = {
        postIds: postIds,
        targetAuditStatus: 1,
        status: 1,
        businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
        tenantId: parseInt(this.$route.query.tenantid),
      };

      jdh_qz_man_post_batch_audit(params)
        .then((res) => {
          this.$message({
            message: res ? "审核成功" : "审核失败",
            type: "success",
          });
        })
        .then(() => {
          // 京东GO（轻盈咔）新增审核接口
          this.handleJdGoAudit({
            status: this.jdGoStatus,
            contentId: data,
          });
          this.dialogSetCircle = false;
          this.getArticleList();
        });
    },
    confirmMultDeny() {
      if (this.selectedRows && this.selectedRows.length !== 0) {
        MessageBox.confirm("确定要批量审核拒绝选中的帖子吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.handleMultiDeny();
          })
          .then(() => {
            this.getArticleList();
          })
          .catch(() => {
            ElMessage({
              type: "info",
              message: "已取消批量审核",
            });
          });
      } else {
        this.$message.error("请先选择帖子");
      }
    },
    confirmSingleDeny(data) {
      MessageBox.confirm("确定要审核拒绝选中的帖子吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.handleSingleDeny(data);
        })
        .then(() => {
          this.handleJdGoAudit({
            status: this.jdGoStatus,
            contentId: data,
          });
          this.dialogSetCircle = false;
          this.getArticleList();
        })
        .catch(() => {
          ElMessage({
            type: "info",
            message: "已取消批量审核",
          });
        });
    },
    handleMultiDeny() {
      // 初始化一个空数组 postIds 用于存储每个 post 的 postId
      const postIds = [];

      // 遍历 posts 数组，提取每个 post 的 postId 并放入 postIds 数组中
      this.selectedRows.forEach((post) => {
        postIds.push(post.postId);
      });

      // 创建一个包含 postIds 和 targetAuditStatus 的对象 params
      const params = {
        postIds: postIds,
        targetAuditStatus: 2,
        status: 2,
        businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
        tenantId: parseInt(this.$route.query.tenantid),
      };

      jdh_qz_man_post_batch_audit(params)
        .then((res) => {
          this.$message({
            message: res ? "审核成功" : "审核失败",
            type: "success",
          });
        })
        .then(() => {
          this.getArticleList();
        });
    },
    handleSingleDeny(data) {
      // 初始化一个空数组 postIds 用于存储每个 post 的 postId
      const postIds = [];

      postIds.push(data);

      // 创建一个包含 postIds 和 targetAuditStatus 的对象 params
      const params = {
        postIds: postIds,
        targetAuditStatus: 2,
        status: 2,
        businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
        tenantId: parseInt(this.$route.query.tenantid),
      };

      jdh_qz_man_post_batch_audit(params)
        .then((res) => {
          this.$message({
            message: res ? "审核成功" : "审核失败",
            type: "success",
          });
        })
        .then(() => {
          this.getArticleList();
        });
    },
    handleReset() {
      this.activeName = "all";
      this.searchParams = {
        title: "",
        auditStatus: "",
        postIds: "",
        communityIds: "",
        titleSearchKeyword: "",
        contentSearchKeyword: "",
        postLevelList: [],
        communityPostType: [],
        auditor: "",
        authorPin: "",
        contributeTime: "",
      };
      this.searchParams.auditStatus = "";
      jdh_qz_man_post_page({
        tenantId: parseInt(this.$route.query.tenantid),
        businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
        pageNo: 1,
        pageSize: this.paginationDataProduct.pageSize,
        // communityId:this.searchParams.communityId,
        title: this.searchParams.title,
        auditStatus: "",
        postIds: this.searchParams.postIds,
        communityIds: this.searchParams.communityIds,
        titleSearchKeyword: this.searchParams.titleSearchKeyword,
        contentSearchKeyword: this.searchParams.contentSearchKeyword,
        postLevelList: this.searchParams.postLevelList,
        communityPostTypes: this.searchParams.communityPostType,
        auditor: this.searchParams.auditor,
        authorPin: this.searchParams.authorPin,
        contentLabelIds: this.searchParams?.contentLabelIds?.trim()
          ? this.searchParams.contentLabelIds?.split(",")
          : [],
        beginTime: utils.isEmpty(this.searchParams.contributeTime)
          ? null
          : utils.timetamp(Number(this.searchParams.contributeTime[0])), // 开始时间
        endTime: utils.isEmpty(this.searchParams.contributeTime)
          ? null
          : utils.timetamp(Number(this.searchParams.contributeTime[1])), // 结束时间
      }).then((res) => {
        this.tableData.tableList.splice(0, this.tableData.tableList.length);
        res.data.map((item) => {
          item.submitTime = this.formatDate(item.submitTime);
          if (item.auditStatus == 0) {
            item.auditStatusCheck = "待审核";
          } else if (item.auditStatus == 1) {
            item.auditStatusCheck = "审核通过";
          } else if (item.auditStatus == 2) {
            item.auditStatusCheck = "审核拒绝";
          }
          item.communityPostType = this.getCommunityPostType(
            item?.communityPostType
          );
          this.tableData.tableList.push(item);
        });
        this.paginationDataProduct.total = res.totalCount;
        this.paginationDataProduct.currentPage = res.pageNo;
        this.paginationDataProduct.pageSize = res.pageSize;
        if (this.type != "pageChange" && this.isSelected) {
          this.isSelected = false;
        }
        console.log(
          "???",
          res.data,
          this.tableData,
          this.tableData.tableList[1]
        );
      });
    },
    handleSearch() {
      debugger;
      if (this.activeName == "pending") {
        this.searchParams.auditStatusCheck = 0;
      } else if (this.activeName == "passed") {
        this.searchParams.auditStatusCheck = 1;
      } else if (this.activeName == "offline") {
        this.searchParams.auditStatusCheck = 2;
      } else {
        this.searchParams.auditStatusCheck = "";
      }
      jdh_qz_man_post_page({
        tenantId: parseInt(this.$route.query.tenantid),
        businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
        pageNo: 1,
        pageSize: this.paginationDataProduct.pageSize,
        // communityId:this.searchParams.communityId,
        title: this.searchParams.title,
        auditStatus: this.searchParams.auditStatusCheck,
        postIds: this.searchParams.postIds,
        communityIds: this.searchParams.communityIds,
        titleSearchKeyword: this.searchParams.titleSearchKeyword,
        contentSearchKeyword: this.searchParams.contentSearchKeyword,
        postLevelList: this.searchParams.postLevelList,
        communityPostTypes: this.searchParams.communityPostType,
        auditor: this.searchParams.auditor,
        authorPin: this.searchParams.authorPin,
        contentLabelIds: this.searchParams?.contentLabelIds?.trim()
          ? this.searchParams.contentLabelIds?.split(",")
          : [],
        beginTime: utils.isEmpty(this.searchParams.contributeTime)
          ? null
          : utils.timetamp(Number(this.searchParams.contributeTime[0])), // 开始时间
        endTime: utils.isEmpty(this.searchParams.contributeTime)
          ? null
          : utils.timetamp(Number(this.searchParams.contributeTime[1])), // 结束时间
      }).then((res) => {
        this.tableData.tableList.splice(0, this.tableData.tableList.length);
        res.data.map((item) => {
          item.submitTime = this.formatDate(item.submitTime);
          if (item.auditStatus == 0) {
            item.auditStatusCheck = "待审核";
          } else if (item.auditStatus == 1) {
            item.auditStatusCheck = "审核通过";
          } else if (item.auditStatus == 2) {
            item.auditStatusCheck = "审核拒绝";
          }
          item.communityPostType = this.getCommunityPostType(
            item?.communityPostType
          );
          this.tableData.tableList.push(item);
        });
        this.paginationDataProduct.total = res.totalCount;
        this.paginationDataProduct.currentPage = res.pageNo;
        this.paginationDataProduct.pageSize = res.pageSize;
        if (this.type != "pageChange" && this.isSelected) {
          this.isSelected = false;
        }
        console.log(
          "???",
          res.data,
          this.tableData,
          this.tableData.tableList[1]
        );
      });
    },
    handleInitSearch(data) {
      if (this.searchParams.auditStatus == "待审核") {
        this.searchParams.auditStatusCheck = 0;
      } else if (this.searchParams.auditStatus == "审核通过") {
        this.searchParams.auditStatusCheck = 1;
      } else if (this.searchParams.auditStatus == "审核拒绝") {
        this.searchParams.auditStatusCheck = 2;
      } else {
        this.searchParams.auditStatusCheck = "";
      }
      jdh_qz_man_post_page({
        tenantId: parseInt(this.$route.query.tenantid),
        businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
        pageNo: 1,
        pageSize: this.paginationDataProduct.pageSize,
        // communityId:this.searchParams.communityId,
        title: this.searchParams.title,
        auditStatus: this.searchParams.auditStatusCheck,
        postIds: this.searchParams.postIds,
        communityIds: data,
        titleSearchKeyword: this.searchParams.titleSearchKeyword,
        contentSearchKeyword: this.searchParams.contentSearchKeyword,
        postLevelList: this.searchParams.postLevelList,
        communityPostTypes: this.searchParams.communityPostType,
        auditor: this.searchParams.auditor,
        authorPin: this.searchParams.authorPin,
        contentLabelIds: this.searchParams?.contentLabelIds?.trim()
          ? this.searchParams.contentLabelIds?.split(",")
          : [],
        beginTime: utils.isEmpty(this.searchParams.contributeTime)
          ? null
          : utils.timetamp(Number(this.searchParams.contributeTime[0])), // 开始时间
        endTime: utils.isEmpty(this.searchParams.contributeTime)
          ? null
          : utils.timetamp(Number(this.searchParams.contributeTime[1])), // 结束时间
      }).then((res) => {
        this.tableData.tableList.splice(0, this.tableData.tableList.length);
        res.data.map((item) => {
          item.submitTime = this.formatDate(item.submitTime);
          if (item.auditStatus == 0) {
            item.auditStatusCheck = "待审核";
          } else if (item.auditStatus == 1) {
            item.auditStatusCheck = "审核通过";
          } else if (item.auditStatus == 2) {
            item.auditStatusCheck = "审核拒绝";
          }
          item.communityPostType = this.getCommunityPostType(
            item?.communityPostType
          );
          this.tableData.tableList.push(item);
        });
        this.paginationDataProduct.total = res.totalCount;
        this.paginationDataProduct.currentPage = res.pageNo;
        this.paginationDataProduct.pageSize = res.pageSize;
        if (this.type != "pageChange" && this.isSelected) {
          this.isSelected = false;
        }
      });
    },
    getBusinessId(key) {
      return getBusinessId(key);
    },
    remoteMethod(query) {
      console.log("==== query quanziList", query);
      qzManPage({
        pageNo: 1,
        pageSize: 100, // 后端设定 夜迷不可能超过100 后期优化非分页
        tenantId: parseInt(this.$route.query.tenantid),
        businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
        status: 1,
        communityName: query,
      }).then((res) => {
        console.log("query quanziList", res);
        this.communityOptions = (res.data || [])?.map((item) => ({
          value: item.communityId,
          label: item.communityName,
        }));
        console.log("getCommunitySelect", res);
      });
    },
    onClearSelect() {
      console.log("==== onClear");
      qzManPage({
        pageNo: 1,
        pageSize: 100, // 后端设定 夜迷不可能超过100 后期优化非分页
        tenantId: parseInt(this.$route.query.tenantid),
        businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
        status: 1,
      }).then((res) => {
        console.log("reset", res);
        this.communityOptions = (res.data || [])?.map((item) => ({
          value: item.communityId,
          label: item.communityName,
        }));
      });
    },
    onPostSelect() {
      console.log("==== onClear");
      qzManPage({
        pageNo: 1,
        pageSize: 100, // 后端设定 夜迷不可能超过100 后期优化非分页
        tenantId: parseInt(this.$route.query.tenantid),
        businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
        status: 1,
      }).then((res) => {
        console.log("reset", res);
        this.communityOptions = (res.data || [])?.map((item) => ({
          value: item.communityId,
          label: item.communityName,
        }));
      });
    },
    handleJdGoAudit(params) {
      subject_auditPostQuality({
        tenantId: parseInt(this.$route.query.tenantid),
        status: params.status || 2,
        contentId: params.contentId,
        contentType: "health_circle_image_text",
      }).then(() => {
        this.jdGoStatus = 2;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.content-audit-tabel {
  position: relative;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  background: white;
  margin-top: 14px;

  .import-btn {
    position: absolute;
    right: 20px;
    top: 20px;
    z-index: 11;

    .redTag {
      color: red;
    }
  }
}

.slot-item {
  span {
    margin: 0px 2px 0px 2px;
  }
}

:deep(.el-textarea__inner) {
  min-height: 130px !important;
  resize: none;
}

:deep(.el-form-item) {
  margin-bottom: 22px;
}

:deep(.modal-body) {
  margin-top: 30px;
}

.reasonDom {
  padding: 0 30px;
  height: 100px;
  line-height: 20px;
  font-size: 14px;
  color: rgba(44, 52, 67, 1);
  /*overflow: hidden;*/
  overflow-y: auto;
  max-height: 150px;
}

.freezeDom {
  /*margin-top: 30px;*/
  .freezeInp {
    max-height: 130px;
    max-width: 276px;

    // overflow: hidden;
    .el-input__count {
      background: rgba(0, 0, 0, 0);
      bottom: -30px;
    }
  }

  .mar-top30 {
    margin-top: 30px;
  }
}

.importBtn {
  display: inline-flex;
  align-items: flex-start;
  justify-content: center;
  margin-left: 5px;
}

.exportBtn {
  margin-left: 5px;

  span {
    margin-top: 5px;
    display: block;
    color: #abaaaa;
  }
}

.dropDown {
  margin-left: 10px;
}

.header-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header {
  font-size: 20px;
  font-weight: bold;
}

.form-container {
  height: 100vh;
  padding-bottom: 200px;
  /* 设置固定高度 */
  overflow-y: auto;
  /* 启用垂直滚动条 */
}

:deep(.el-form-item__label) {
  font-weight: bold;
  /* 加粗 */
  margin-right: 20px;
  /* 右边距 */
}

.image-flex {
  display: flex;
  flex-wrap: wrap;
  /* 自动换行 */
  gap: 10px;
  /* 图片间距 */
}

.image-item {
  position: relative;
  width: calc(33.33% - 10px);
  /* 每行3个，减去间距 */
  height: 100px;
  /* 设置图片容器高度 */
  overflow: hidden;
  margin-bottom: 10px;
  /* 图片之间的垂直间距 */
}

.image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* 图片覆盖容器 */
  cursor: pointer;
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.3s;
}

.image-item:hover .image-overlay {
  opacity: 1;
}

.image-overlay .el-button {
  margin: 0 5px;
}

.search-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

.input-group {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  width: 100%;
  justify-content: flex-start;
}

.button-group {
  display: flex;
  gap: 10px;
}

.multiSelect {
  display: flex;
  align-items: center;
  // justify-content: center;
  font-size: 16px;
  margin-bottom: 10px;
}

.select-blue {
  margin-right: 5px;
  // color: blue;
}

.select-white {
  margin-right: 5px;
  color: rgb(0, 0, 0);
}

.drawer-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 10px;
  border-top: 1px solid #ebeef5;
  background-color: #fff;
  /* 确保背景色 */
}

.drawer-footer .el-button {
  margin-left: 10px;
}
</style>
